import { render, staticRenderFns } from "./DeliveredCompanyTable.vue?vue&type=template&id=cc40a0c4&scoped=true&"
import script from "./DeliveredCompanyTable.vue?vue&type=script&lang=js&"
export * from "./DeliveredCompanyTable.vue?vue&type=script&lang=js&"
import style0 from "./DeliveredCompanyTable.vue?vue&type=style&index=0&id=cc40a0c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc40a0c4",
  null
  
)

export default component.exports